import { Component, ElementRef, Input, OnInit, QueryList, ViewChildren } from '@angular/core';

@Component({
  selector: 'app-buy-sell-reviewers-list',
  templateUrl: './buy-sell-reviewers-list.component.html',
  styleUrls: ['./buy-sell-reviewers-list.component.scss']
})
export class BuySellReviewersListComponent implements OnInit {
  @Input() buySellPlanApprovals: any[];
  @ViewChildren('commentSection') commentSections: QueryList<ElementRef<HTMLElement>>;
  
  constructor() { }

  ngOnInit(): void {
  }

  onPanelOpened(index: number): void {
    setTimeout(() => {
      const sections = this.commentSections?.toArray();
      if (sections?.[index]) {
        sections[index].nativeElement.focus();
      }
    });
  }

  getStatusChipClass(statusId): string {
    const classMap = {
      'DENIED': 'red-chip',
      'APPROVED': 'green-chip',
      'Complete': 'green-chip',
      'PENDING': 'orange-chip',
      'PENDING_APPROVAL': 'orange-chip',
      'AVAILABLE': 'blue-chip'
    };
    return classMap[statusId] || '';
  }

}
